module.exports = __webpack_public_path__ + "img/kokura.99113112.jpg";